<div class="toolbar-container bg-white p-3 rounded-top">
  <div class="d-flex align-items-center gap-3 w-100">
    <div class="d-flex align-items-center gap-3 text-sm">
      <div class="d-flex align-items-center gap-1">
        <div class="rounded-circle" style="width: 12px; height: 12px; background-color: #55ae2b"></div>
        <span i18n>AI active</span>
      </div>
      <div class="d-flex align-items-center gap-1">
        <div class="rounded-circle bg-warning" style="width: 12px; height: 12px"></div>
        <span i18n>AI partially active</span>
      </div>
      <div class="d-flex align-items-center gap-1">
        <div class="rounded-circle bg-danger" style="width: 12px; height: 12px"></div>
        <span i18n>AI OFF</span>
      </div>
    </div>
    <div class="flex-fill"></div>
    <button
      class="btn btn-outline-light"
      (click)="gotoToday()"
      i18n-matTooltip
      matTooltip="Go to Today"
      matTooltipPosition="below"
      i18n
    >
      Today
    </button>

    <button
      class="btn btn-secondary-primary"
      (click)="refresh()"
      i18n-matTooltip
      matTooltip="Refresh"
      matTooltipPosition="below"
    >
      <i class="far fa-sync"></i>
    </button>
    <app-select-nav
      class="field-months"
      [disablePrevious]="!(canNavigate | call : selectedMonth : months : 'prev')"
      [disableNext]="!(canNavigate | call : selectedMonth : months : 'next')"
      (previous)="onChangeMonth('prev')"
      (next)="onChangeMonth('next')"
    >
      <mat-select placeholder="Select month" [(ngModel)]="selectedMonth" (selectionChange)="onChangeMonth()">
        <ng-container *ngFor="let month of months">
          <mat-option *ngIf="isInYear | call : month : selectedYear" [value]="month">{{
            month | epochUTC : 'MMMM'
          }}</mat-option>
        </ng-container>
      </mat-select>
    </app-select-nav>

    <app-select-nav
      class="field-years"
      [disablePrevious]="!(canNavigate | call : selectedYear : years : 'prev')"
      [disableNext]="!(canNavigate | call : selectedYear : years : 'next')"
      (previous)="onChangeYear('prev')"
      (next)="onChangeYear('next')"
    >
      <mat-select
        i18n-placeholder
        placeholder="Select year"
        [(ngModel)]="selectedYear"
        (selectionChange)="onChangeYear()"
      >
        <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
      </mat-select>
    </app-select-nav>
  </div>
</div>

<div class="calendar-container bg-white px-3 pb-3 rounded-bottom">
  <ngx-calendar-list
    #calendarList
    [prepareEventsOnViewportChange]="true"
    weekdayFormat="short"
    [months]="months"
    [events]="events"
    [getEventID]="getEventID"
    [getEventTimeRange]="getEventTimeRange"
    [eventHeight]="45"
    [eventMargin]="40"
    [initialDate]="today"
    [selectable]="false"
    (viewportChange)="onViewportChange($event)"
    (selectionChange)="onSelectionChange($event)"
  >
    <app-ai-off-calendar-cell
      *ngxCalendarListDayCell="let day"
      [day]="day"
      [today]="day === today"
      [beforeToday]="isBeforeToday | call : day"
      [startOfMonth]="isStartOfMonth | call : day"
      (click)="onDayClick(day)"
    >
    </app-ai-off-calendar-cell>
  </ngx-calendar-list>
</div>
